import { Directive, input } from '@angular/core';

@Directive({
  selector: '[ocpTruncate]',
  host: {
    '[style.display]': '"block"',
    '[style.min-width]': 'minWidth() ?? 0',
    '[style.max-width]': 'maxWidth()',
    '[style.overflow]': '"hidden"',
    '[style.text-overflow]': '"ellipsis"',
    '[style.white-space]': '"nowrap"',
  },
})
export class TruncateDirective {
  minWidth = input<string | undefined>(undefined);
  maxWidth = input<string | undefined>(undefined);
}
